export default __webpack_public_path__ + "static/media/vire21.183159cd.jpg";